import { i18n, readLocaleFromPath } from './config'
import { DEFAULT_LOCALE, isRtlLocale, isSupportedLocale, type SupportedLocale } from './locales'

/**
 * Applies the path-segment locale (when present) before React mounts.
 *
 * Replaces the pre-i18n `installTubeMapTitle()` bootstrap: that helper
 * resolved a single `<title>` from `navigator.language`; this one drives
 * `<html lang>`, `<html dir>` and seeds i18next so the SPA renders
 * directly in the routed locale on first paint. The actual `<title>` /
 * `<meta>` per page is managed by `<HelmetProvider>` from
 * `react-helmet-async` once the page component mounts.
 */
export function installI18nFromPath(pathname: string = window.location.pathname): SupportedLocale {
  const fromPath = readLocaleFromPath(pathname)
  const locale: SupportedLocale =
    fromPath !== null && isSupportedLocale(fromPath) ? fromPath : DEFAULT_LOCALE
  document.documentElement.lang = locale
  document.documentElement.dir = isRtlLocale(locale) ? 'rtl' : 'ltr'
  if (i18n.language !== locale) {
    void i18n.changeLanguage(locale)
  }
  return locale
}
